import React from 'react';
import { AlertTriangle, TrendingDown, Shield } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';

const RiskDisclosure = () => {
  return (
    <div className="dark-container min-h-screen pt-28 pb-20">
      <div className="max-w-5xl mx-auto px-6 md:px-12">
        <div className="text-center mb-12">
          <div className="w-20 h-20 mx-auto mb-6 bg-red-500/10 border border-red-500 rounded-sm flex items-center justify-center">
            <AlertTriangle className="text-red-500" size={36} />
          </div>
          <h1 className="display-large mb-4" style={{ color: 'var(--text-primary)' }}>Risk Disclosure</h1>
          <p className="body-medium text-red-500">Please read carefully before investing</p>
        </div>

        <Card className="bg-red-500/5 border border-red-500/30 backdrop-blur-xl mb-8">
          <CardContent className="p-8">
            <div className="bg-red-500/10 border border-red-500/30 rounded-lg p-6 mb-8">
              <h3 className="heading-2 text-red-500 mb-3">⚠️ HIGH RISK WARNING</h3>
              <p style={{ color: 'var(--text-secondary)' }}>
                Cryptocurrency and token investments carry extreme risk. You may lose your entire investment. Only invest what you can afford to lose completely.
              </p>
            </div>
            
            <h2 className="heading-1 mb-4" style={{ color: 'var(--text-primary)' }}>1. Volatility Risk</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              Token prices can fluctuate dramatically within hours. 50-90% price drops are common, especially for new tokens. Past performance does not guarantee future results.
            </p>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>2. Project Failure Risk</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              Despite our vetting process, projects may fail due to:
            </p>
            <ul className="space-y-2 mb-6" style={{ color: 'var(--text-secondary)' }}>
              <li>• Technical challenges and development delays</li>
              <li>• Market conditions and lack of adoption</li>
              <li>• Team disputes or mismanagement</li>
              <li>• Regulatory actions</li>
              <li>• Competitive pressures</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>3. Liquidity Risk</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              You may not be able to sell tokens immediately or at favorable prices. Some tokens may have:
            </p>
            <ul className="space-y-2 mb-6" style={{ color: 'var(--text-secondary)' }}>
              <li>• Lock-up periods restricting sales</li>
              <li>• Low trading volumes making sales difficult</li>
              <li>• Vesting schedules delaying token access</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>4. Smart Contract Risk</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              Smart contracts may contain bugs, vulnerabilities, or be subject to exploits despite audits. Funds could be permanently lost due to code errors.
            </p>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>5. Regulatory Risk</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              Cryptocurrency regulations are evolving globally. Changes in laws may:
            </p>
            <ul className="space-y-2 mb-6" style={{ color: 'var(--text-secondary)' }}>
              <li>• Restrict token trading or use</li>
              <li>• Require additional compliance measures</li>
              <li>• Impact token values negatively</li>
              <li>• Limit platform operations in certain jurisdictions</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>6. Fraud and Security Risks</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              Despite our security measures, risks include:
            </p>
            <ul className="space-y-2 mb-6" style={{ color: 'var(--text-secondary)' }}>
              <li>• Phishing attacks and social engineering</li>
              <li>• Wallet compromise or key loss</li>
              <li>• Exchange hacks or platform breaches</li>
              <li>• Rug pulls or exit scams (despite vetting)</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>7. No Guarantees</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              MatrixLaunch does not guarantee:
            </p>
            <ul className="space-y-2 mb-6" style={{ color: 'var(--text-secondary)' }}>
              <li>• Investment returns or profits</li>
              <li>• Token listing on exchanges</li>
              <li>• Project success or delivery</li>
              <li>• Refunds or compensation for losses</li>
            </ul>
            
            <h2 className="heading-1 mb-4 mt-8" style={{ color: 'var(--text-primary)' }}>8. Tax Implications</h2>
            <p className="mb-4" style={{ color: 'var(--text-secondary)' }}>
              Token investments may have tax consequences in your jurisdiction. You are responsible for understanding and complying with tax obligations.
            </p>
            
            <div className="bg-brand-primary/10 border border-brand-primary rounded-lg p-6 mt-8">
              <h3 className="heading-2 text-brand-primary mb-3">Professional Advice Recommended</h3>
              <p style={{ color: 'var(--text-secondary)' }}>
                We strongly recommend consulting with financial, legal, and tax professionals before making investment decisions. This platform does not provide investment advice.
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default RiskDisclosure;
